import { gql } from '@apollo/client';

export const CreateExportGuestUsersRequest = gql`
  mutation CreateExportGuestUsersRequest(
    $organizationCode: String!
    $personIdentifiers: [String]
    $columns: [ExportedColumn!]
    $textSearch: String
  ) {
    createExportGuestUsersRequest(
      organizationCode: $organizationCode
      personIdentifiers: $personIdentifiers
      columns: $columns
      textSearch: $textSearch
    )
  }
`;
